import regex from "@/constants/validation.constants";
import * as Yup from "yup";

export const signupSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string(),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  country: Yup.string().required("Country is required"),
  password: Yup.string()
    .matches(regex.password.regex, regex.password.message())
    .required("Password is required"),
});
